import { EmployeePayTypeTitle } from 'typings/enums';

export const GetAllEmployeePayTypeTitles = (): EmployeePayTypeTitle[] => {
    return [
        EmployeePayTypeTitle.LastPaidSti,
        EmployeePayTypeTitle.OtherCash,
        EmployeePayTypeTitle.Commissions
    ];
};